import React from 'react';
import { Badge } from 'components/common';

// Cell renderer for status with badge
const StatusRenderer = (params) => {
  if (!params.value) return null;
  const variant = params.value === 'open' ? 'default' : 'success';
  return <Badge variant={variant} size="sm" className="tw-capitalize">{params.value}</Badge>;
};

export default StatusRenderer;
